import moment from 'moment'

const columnsData = {
    evalreqList: (action, decline, view) => [
        {
            field: 'index', // This can be any unique field name
            headerName: 'Letter', // You can name this column as 'Index', 'No.', or any other suitable title
            width: 55,
        },
        {
            field: 'applicantFullName',
            headerName: 'Applicant',
            width: 100,
        },
        { field: 'applicantUserId', headerName: 'TMDSAS Id', width: 100 },
        {
            field: 'letterRequestStatusDescr',
            headerName: 'Request Status',
            width: 120,
        },
        {
            field: 'entryYear',
            headerName: 'Entry Year',
        },
        // {
        //     field: 'evaluatorName',
        //     headerName: 'Evaluator',
        //     width: 110,
        // },
        {
            field: 'collegeType',
            headerName: 'Letter',
            width: 105,
        },
        {
            field: 'isUploaded',
            headerName: 'Action',
            width: 120,
            renderCell: action,
            valueFormatter: (params) => {
                const valueFormatted = params.value
                return `${valueFormatted}`
            },
            // disableClickEventBubbling: true,
        },
        {
            field: 'view',
            headerName: 'View',
            width: 90,
            renderCell: view,
        },
        {
            field: 'decline',
            headerName: 'Decline',
            width: 150,
            renderCell: decline,
            // disableClickEventBubbling: true,
        },
        {
            field: 'createdDate',
            headerName: 'Request Date',
            width: 110,
            valueFormatter: (params) => {
                const valueFormatted = params.value
                const dateTime = moment(valueFormatted).format('MM-DD-YYYY')
                return `${dateTime}`
            },
        },
        {
            field: 'documentStatus',
            headerName: 'Administrator Review',
            width: 160,
        },
        {
            field: 'letterRequestMethodDescr',
            headerName: 'Letter Request Method',
            width: 165,
        },
        {
            field: 'electronicSignedBy',
            headerName: 'Electronically Signed by',
            width: 170,
        },
        {
            field: 'evaluatorSignatureDate',
            headerName: 'Signed Date',
            //   width: 110,
            valueFormatter: (params) => {
                if (params.value) {
                    const valueFormatted = params.value
                    const dateTime = moment(valueFormatted).format('MM-DD-YYYY')
                    return `${dateTime}`
                }
            },
        },
        {
            field: 'confidentialityRightsWaiver',
            headerName: 'Waiver',
            //   width: 110,
            valueFormatter: (params) => {
                const valueFormatted = params.value == true ? 'Yes' : 'No'
                return `${valueFormatted}`
            },
        },
    ],
}

export default columnsData
